<template>
  <BModal v-bind="$attrs" no-close-on-backdrop>
    <template v-slot:header>
      <h4 class="modal-title">{{ $t('login.agreementModal.title') }}</h4>
      <button type="button" class="btn-close" @click="close" :aria-label="$t('close')" />
    </template>

    <template v-slot:default>
      <ValidationGroup alwaysSubmit @submit="submit" ref="form">
        <template v-slot:default="{ valid, submitted, touched }">
          <p
            v-html="$t('login.agreementModal.introduction', {
              link: `<a href='${termsLink}' target='_blank'>${$tm('login.agreementModal.termOfUse')}</a>`,
            })" />
          <span class="caption text-end d-block marker mb-2">
            <span class="marker step-by-step">*</span>
            {{ $t('login.agreementModal.indicatesFields') }}
          </span>

          <div class="structured-inner-wrapper">
            <div class="form-wrapper">
              <p>{{ $t('login.agreementModal.privacyNotice') }}</p>
              <div class="row">
                <ValidationField highlight :value="details.email" class="mb-3 col-12 col-md-6" email>
                  <template v-slot:default>
                    <label>{{ $t('login.agreementModal.email') }}</label>
                    <input type="email" class="form-control" v-model="details.email" name="email">
                  </template>
                  <template v-slot:error>
                    <span class="invalid-feedback">{{ $t('login.agreementModal.validation.email') }}</span>
                  </template>
                </ValidationField>
                <ValidationField highlight class="mb-3 col-12 col-md-6" :value="details.phone" phone>
                  <template v-slot:default>
                    <label>{{ $t('login.agreementModal.phone') }}</label>
                    <input class="form-control" v-model="details.phone" name="phone">
                  </template>
                  <template v-slot:error>
                    <span class="invalid-feedback">{{ $t('login.mobileID.details.phone') }}</span>
                  </template>
                </ValidationField>
              </div>
            </div>

            <ValidationField required highlight type="checkbox" :value="details.isAgreed">
              <template v-slot:default="{ validityClass }">
                <Checkbox
                  name="isAgreed"
                  label-class="mb-0 mt-0"
                  :class="validityClass"
                  v-model="details.isAgreed"
                >
                  <span class="marker step-by-step">*</span>
                  <span
                    v-html="$t('login.agreementModal.agreement', {
                      link: `<a href='${termsLink}' target='_blank'>${$tm('login.agreementModal.termOfUse')}</a>`,
                    })" />
                </Checkbox>
              </template>
              <template v-slot:error>
                <span class="invalid-feedback">{{ $t('login.agreementModal.validation.isAgreed') }}</span>
              </template>
            </ValidationField>
          </div>

          <SubscriptionForm
            @change="mergeSubscription"
            :info="$t('newsletter.info', {
              link: `<a href='${termsLink}' target='_blank'>${$tm('login.agreementModal.fromTermOfUse')}</a>`,
            })"
            :labelCheckbox="$t('newsletter.consentCheckbox')"
          >
            <template v-slot:validationFeedback>
              <span class="invalid-feedback">{{ $t('login.agreementModal.validation.email') }}</span>
            </template>
          </SubscriptionForm>
          <Messages id="agreement" v-if="!touched || submitted && !valid" />
        </template>
      </ValidationGroup>
    </template>

    <template v-slot:footer>
      <button
        type="button"
        class="btn btn-lg btn-success"
        @click="$refs.form.submit()"
        name="submit"
        :disabled="isCreateBtnDisabled">
        {{ $t('login.agreementModal.createAccount') }}
      </button>
      <button
        type="button"
        class="btn btn-lg btn-secondary d-md-inline-block"
        @click="close"
        name="cancel"
        :disabled="isCreateBtnDisabled">
        {{ $t('cancel') }}
      </button>
    </template>
  </BModal>
</template>

<script>
import { mapActions } from 'vuex';
import Checkbox from './Checkbox';
import ValidationField from './ValidationField';
import ValidationGroup from './ValidationGroup';
import Messages from './Messages';
import SubscriptionForm from './SubscriptionForm';
import { BModal } from 'bootstrap-vue-next';

export default {
  components: {
    BModal,
    Checkbox,
    ValidationField,
    ValidationGroup,
    Messages,
    SubscriptionForm,
  },
  props: ['isCreateBtnDisabled'],
  data: () => ({
    details: {
      email: '',
      phone: '',
      isAgreed: false,
      wantsNewsletter: false,
      subscriptionEmail: '',
    },
  }),
  methods: {
    ...mapActions('alerts', ['showMessage']),

    close() {
      this.$emit('close');
    },
    submit({ valid }) {
      if (valid) {
        this.$emit('agree', this.details);
      } else {
        this.showMessage({
          type: 'danger',
          target: 'agreement',
          text: this.$t('login.agreementModal.validation.error'),
        });
      }
    },
    mergeSubscription(value) {
      Object.assign(this.details, value);
    },
  },
  computed: {
    termsLink() {
      return this.$router.resolve({ name: `terms-${this.$i18n.locale}`, params: { lang: this.$i18n.locale } }).href;
    },
  },
};
</script>
